// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mainAppbar {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
}
.mainAppbar .menuIcon {
  display: none;
}
@media screen and (max-width: 1439px) {
  .mainAppbar .menuIcon {
    display: flex;
  }
}
.mainAppbar .titleContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.mainAppbar .title {
  font-weight: bold;
  font-size: 1.5rem;
}`, "",{"version":3,"sources":["webpack://./src/components/Layout/AppBar/appbar.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,aAAA;AACF;AACE;EACE,aAAA;AACJ;AACI;EAHF;IAII,aAAA;EAEJ;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AACJ;AAEE;EACE,iBAAA;EACA,iBAAA;AAAJ","sourcesContent":[".mainAppbar {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1rem;\n\n  .menuIcon {\n    display: none;\n\n    @media screen and (max-width: 1439px ) {\n      display: flex;\n    }\n  }\n\n  .titleContainer {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100% ;\n  }\n\n  .title {\n    font-weight: bold;\n    font-size: 1.5rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
